import { Link } from 'react-router-dom';
import { localeStore } from '~/mobx/localesStore';
import './style.scss';

type LogLinkProps = {
  link: string;
};

const LogLink = ({ link }: LogLinkProps) => {
  return (
    <Link to={link} className="log-link color-mainblue text-size-14 family-regular">
      {localeStore.t('view_log')}
    </Link>
  );
};

export default LogLink;
